import AdsService from "./services/AdsService/AdsService";
import AuthService from "./services/authentication/AuthService";
import BoostService from "./services/BoostService/BoostService";
import CollectionService from "./services/CollectionsService/CollectionsService";
import CreatorsService from "./services/CreatorsService/CreatorsService";
import CsatService from "./services/CsatService/CsatService";
import ExperimentsService from "./services/ExperimentsService/ExperimentsService";
import FeedsService from "./services/FeedsService/FeedsService";
import FollowService from "./services/FollowService/FollowService";
import GifsService from "./services/GifsService/GifsService";
import MeService from "./services/MeService/MeService";
import MetricsService from "./services/MetricsService/MetricsService";
import EventsService from "./services/EventsService/EventsService";
import GeoService from "./services/GeoService/GeoService";
import NichesService from "./services/NichesService/NichesService";
import AnnouncementsService from "./services/AnnouncementsService/AnnouncementsService";
import OAuthService from "./services/authentication/OAuthService";
import PinsService from "./services/PinsService/PinsService";
import RecommendationsService from "./services/RecommendationsService/RecommendationsService";
import SocialLinksService from "./services/SocialLinksService/SocialLinksService";
import SearchService from "./services/SearchService/SearchService";
import TagsService from "./services/TagsService/TagsService";
import UploadService from "./services/UploadService/UploadService";
import UsersService from "./services/UsersService/UsersService";
import VerificationService from "./services/VerificationService/VerificationService";
import VisitorService from "./services/VisitorService/VisitorService";

import { HttpClient } from "./http/HttpClient";
import AuthenticatedHttpClient from "./http/AuthenticatedHttpClient";
import PremiumService from "@/common/api/services/PremiumService/PremiumService";

const httpClient = new HttpClient();
const authHttpClient = new AuthenticatedHttpClient();

export const apiAuth = new AuthService(httpClient);
export const apiAds = new AdsService(authHttpClient);
export const apiBoost = new BoostService(authHttpClient);
export const apiCollections = new CollectionService(authHttpClient);
export const apiCreators = new CreatorsService(authHttpClient);
export const apiCsat = new CsatService(authHttpClient);
export const apiExperiments = new ExperimentsService(authHttpClient);
export const apiFollow = new FollowService(authHttpClient);
export const apiFeeds = new FeedsService(authHttpClient);
export const apiGifs = new GifsService(authHttpClient);
export const apiMetrics = new MetricsService(authHttpClient);
export const apiEvents = new EventsService(authHttpClient);
export const apiMe = new MeService(authHttpClient);
export const apiNiches = new NichesService(authHttpClient);
export const apiRecommendations = new RecommendationsService(authHttpClient);
export const apiSearch = new SearchService(authHttpClient);
export const apiSocialLinks = new SocialLinksService(authHttpClient);
export const apiTags = new TagsService(authHttpClient);
export const apiUsers = new UsersService(authHttpClient);
export const apiAnnouncements = new AnnouncementsService(authHttpClient);
export const apiPins = new PinsService(authHttpClient);
export const apiOAuth = new OAuthService(authHttpClient);
export const apiGeo = new GeoService(authHttpClient);
export const apiUpload = new UploadService(authHttpClient);
export const apiVisitor = new VisitorService(authHttpClient);
export const apiVerification = new VerificationService(authHttpClient);
export const apiPremium = new PremiumService(authHttpClient);

export * from "./services";
